// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Point} from './point.js'

export class Polygon {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Polygon {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPolygon(bb: flatbuffers.ByteBuffer, obj?: Polygon): Polygon {
    return (obj || new Polygon()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPolygon(bb: flatbuffers.ByteBuffer, obj?: Polygon): Polygon {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new Polygon()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  points(index: number, obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Point()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  pointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPolygon(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addPoints(builder: flatbuffers.Builder, pointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, pointsOffset, 0)
  }

  static startPointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static endPolygon(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // points
    return offset
  }

  static createPolygon(builder: flatbuffers.Builder, pointsOffset: flatbuffers.Offset): flatbuffers.Offset {
    Polygon.startPolygon(builder)
    Polygon.addPoints(builder, pointsOffset)
    return Polygon.endPolygon(builder)
  }
}
